export default "__VITE_ASSET__CrXMaovQ__"